import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
function stylesEqual(oldStyles, newStyles) {
  var keys = Object.keys(oldStyles);
  if (keys.length !== Object.keys(newStyles).length) {
    return false;
  }
  for (var i = 0; i < keys.length; i++) {
    if (oldStyles[keys[i]] !== newStyles[keys[i]]) {
      return false;
    }
  }
  return true;
}
export var Frame = /*#__PURE__*/function (_React$Component) {
  _inherits(Frame, _React$Component);
  var _super = _createSuper(Frame);
  function Frame() {
    _classCallCheck(this, Frame);
    return _super.apply(this, arguments);
  }
  _createClass(Frame, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.children !== this.props.children || !stylesEqual(this.props.style || {}, nextProps.style || {});
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: cx('frame', this.props.className),
        style: this.props.style
      }, this.props.children);
    }
  }]);
  return Frame;
}(React.Component);
_defineProperty(Frame, "componentName", 'Frame');
_defineProperty(Frame, "defaultProps", {
  style: null
});
Frame.propTypes = process.env.NODE_ENV !== "production" ? {
  style: PropTypes.object,
  className: PropTypes.any,
  children: PropTypes.node.isRequired
} : {};